/**
 * HERO_FALLBACK_DATAURI — inlined vector brand backdrop.
 *
 * Shown as the absolute-last-resort placeholder on every card, video, and
 * AR surface when the primary media fails or is still loading. Applied
 * app-wide (BLKCardFrame, VideoMomentCard, PremiumCube, HomePage hero,
 * MarketplacePage tiles, LockerPage grid, AR viewers, etc.) so users NEVER
 * see a flat black rectangle anywhere in the ecosystem.
 *
 * Vector SVG (≈1.3KB) → ships inside the JS bundle → zero network cost,
 * renders in < 10ms even on a first-ever cold load with no connectivity.
 *
 * Visuals: soft radial orange glow, a subtle diagonal gold shine streak,
 * and a centered BLK PACKS monogram chip. Intentionally low-intensity so it
 * reads as "branded backdrop" not "unfinished placeholder" — the vibe
 * matches an unlit card sleeve rather than a big billboard.
 */
const svg = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 420" preserveAspectRatio="xMidYMid slice">
  <defs>
    <linearGradient id="bg" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0%" stop-color="#12121e"/>
      <stop offset="55%" stop-color="#0a0a14"/>
      <stop offset="100%" stop-color="#050509"/>
    </linearGradient>
    <radialGradient id="glow" cx="50%" cy="42%" r="60%">
      <stop offset="0%" stop-color="#f97316" stop-opacity="0.22"/>
      <stop offset="55%" stop-color="#f97316" stop-opacity="0.06"/>
      <stop offset="100%" stop-color="#f97316" stop-opacity="0"/>
    </radialGradient>
    <linearGradient id="shine" x1="0" y1="0" x2="1" y2="1">
      <stop offset="0%" stop-color="#fbbf24" stop-opacity="0"/>
      <stop offset="50%" stop-color="#fbbf24" stop-opacity="0.18"/>
      <stop offset="100%" stop-color="#fbbf24" stop-opacity="0"/>
    </linearGradient>
  </defs>
  <rect width="300" height="420" fill="url(#bg)"/>
  <rect width="300" height="420" fill="url(#glow)"/>
  <!-- subtle diagonal shine streak (low intensity, readable as a premium sleeve, not a billboard) -->
  <polygon points="0,255 300,105 300,165 0,315" fill="url(#shine)"/>
  <!-- centered brand chip -->
  <rect x="90" y="188" width="120" height="44" rx="8" fill="rgba(0,0,0,0.45)" stroke="#f59e0b" stroke-opacity="0.35" stroke-width="1.25"/>
  <text x="150" y="214" text-anchor="middle" font-family="Georgia, serif" font-weight="900" font-size="20" fill="#fbbf24" letter-spacing="2">BLK</text>
  <text x="150" y="226" text-anchor="middle" font-family="Helvetica, Arial, sans-serif" font-weight="900" font-size="7" fill="#fbbf24" opacity="0.7" letter-spacing="4">PACKS</text>
</svg>`.trim().replace(/\n\s*/g, '');

const HERO_FALLBACK_DATAURI = `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`;

export default HERO_FALLBACK_DATAURI;
